<template>
  <div>
    <el-select
      :style="styles"
      :size="size"
      v-model="val"
      filterable
      :multiple="multiple"
      :disabled="disabled"
      :placeholder="placeholder"
      :clearable="clearable"
      @clear="handlerClear"
      @change="handlerChange"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
        :disabled="item.disabled"
      >
        <span style="float: left">{{ item.label }}</span>
        <span v-if="item.showSpan" style="float: right; color: #8492a6; font-size: 13px"
          >已下架</span
        >
      </el-option>
    </el-select>
  </div>
</template>

<script>
  import { getLineList, getAllLineList } from '@/api/public'
  import { getShowSpan, getDisabled } from './utils.line'
  import { cloneDeep } from 'lodash-es'
  import { transFormDataType } from '../utils'

  export default {
    name: 'ComLineSelector',
    props: {
      value: {
        type: [String, Number, Array],
        required: true
      },
      size: {
        type: String,
        default: () => ''
      },
      // 根据供应商ID查询线路
      merchantId: {
        type: [String, Number],
        default: ''
      },
      // 是否展示已下架线路
      showDelete: {
        type: Boolean,
        default: false
      },
      // 是否可选已下架线路
      isCheckDelete: {
        type: Boolean,
        default: false
      },
      // 是否多选
      multiple: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      // 是否数据隔离
      insulate: {
        type: Boolean,
        default: true
      },
      placeholder: {
        type: String,
        default: '请选择线路'
      },
      styles: {
        type: Object,
        default: () => {}
      },
      clearable: {
        type: Boolean,
        default: () => true
      }
    },
    data() {
      return {
        val: undefined,
        list: []
      }
    },
    computed: {
      options() {
        let l = cloneDeep(this.list)
        // 如果展示已下架，则不过滤
        if (this.showDelete) {
          return l
        }
        l = l.filter((item) => !item.disabled)
        return l
      }
    },
    watch: {
      val: {
        handler(newVal, oldVal) {
          if (newVal === oldVal) {
            return
          }
          this.emitInput()
        }
      },
      value: {
        handler(newVal, oldVal) {
          if (newVal === this.val) {
            return
          }
          this.val = transFormDataType(newVal)
        },
        immediate: true
      },
      merchantId: {
        handler(newVal, oldVal) {
          this.getList()
        }
      }
    },
    mounted() {
      this.getList()
    },
    methods: {
      async getList() {
        const { code, data } = this.insulate
          ? await getLineList({ merchantId: this.merchantId })
          : await getAllLineList()
        if (code !== 0) {
          return
        }
        const records = data
        if (!Array.isArray(records)) {
          return
        }
        const l = records.map((item) => {
          const obj = {
            value: item.lineId + '',
            label: item.lineName,
            disabled: getDisabled(item, this.isCheckDelete),
            showSpan: getShowSpan(item, this.isCheckDelete),
            ...item
          }
          return obj
        })
        this.list = l
      },
      emitInput() {
        const v = this.val
        this.$emit('input', v)
      },
      handlerChange(id) {
        if (this.multiple) {
          this.$emit('change', id)
          return
        }
        const item = this.options.find((item) => id === item.value)
        this.$emit('change', item)
      },
      handlerClear() {
        this.$emit('clear')
      }
    }
  }
</script>

<style lang="scss" scoped></style>
